<template>
  <div class="form-floating">
    <input
      :id="passwordId ? passwordId : 'password'"
      :disabled="disabled"
      type="password"
      :maxlength="maxlength"
      v-model="formPassword"
      class="form-control pj-input"
      :class="{ 'is-invalid': errorMessage }"
      autocomplete="off"
      @keyup="updateInput"
      aria-describedby="passwordHelp"
      :placeholder="placeholder"
    />
    <label :for="passwordId ? passwordId : 'password'" class="form-label">{{
      labelName
    }}</label>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div id="passwordHelp" class="form-text"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "NewInputFieldPassword",
  emits: ["input-field-password-emit"],
  props: {
    labelName: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    passwordId: String,
    inputValue: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "256",
    },
    minLength: {
      type: Number,
      default: 6,
    },
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    const formPassword = ref(props.inputValue);
    const errorMessage = ref("");
    const error = ref(false);

    const updateInput = (): void => {
      emit("input-field-password-emit", formPassword.value);
      errorMessage.value = "";
    };

    const validate = (): boolean => {
      if (!formPassword.value) {
        errorMessage.value = t("SHARED.PASSWORD_REQUIRED_ERROR_TEXT");
        error.value = true;
        return false;
      } else if (formPassword.value.length < props.minLength) {
        errorMessage.value = t("SHARED.PASSWORD_INVALID_ERROR_TEXT", {
          length: props.minLength,
        });
        error.value = true;
        return false;
      }
      emit("input-field-password-emit", formPassword.value);
      return true;
    };

    watchEffect(() => {
      if (props.inputValue !== undefined) {
        formPassword.value = props.inputValue;
      }
    });

    const getInputFieldValue = () => {
      return formPassword.value;
    };

    return {
      t,
      formPassword,
      errorMessage,
      getInputFieldValue,
      updateInput,
      validate,
    };
  },
});
</script>
<style lang="scss" scoped>
input {
  border-radius: 5px;
}
</style>
